import { useQuery } from '@tanstack/react-query';
import { fetchScoringPreview } from '@/services/scoring-preview';

export function useScoringPreview(quizId: string | null) {
  return useQuery({
    queryKey: ['admin', 'scoring-preview', quizId],
    queryFn: () => fetchScoringPreview(quizId!),
    enabled: !!quizId,
    staleTime: 60_000,
  });
}
